import type { ChatScope } from '../../src/types/agent';

const CLIENT_PROMPTS = [
  'This week at a glance',
  'Did they hit their workouts?',
  'Sleep vs last week',
  'HRV vs baseline',
  'Any nutrition requests?',
  'Summarize recent messages',
  'How are their forms looking',
] as const;

const ALL_CLIENTS_PROMPTS = [
  'Who needs attention today?',
  'Who should I review first?',
  'Which clients have unreplied check-ins?',
  'Which clients have pain flags?',
  'Which clients have no assigned program?',
  'Which clients look off on recovery?',
  'Give me a quick all-client summary for today.',
] as const;

export function getJarvisQuickPrompts(scopeMode: ChatScope['mode']): readonly string[] {
  return scopeMode === 'client' ? CLIENT_PROMPTS : ALL_CLIENTS_PROMPTS;
}
